<template>
  <el-dialog
    title="选择类目弹窗"
    :visible.sync="categoryVisible"
    width="800px"
    :before-close="categoryCancellHandle"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    :append-to-body="true"
  >
    <div class="category">
      <div class="item-box">
        <div class="item-input-wrap">
          <el-input
            v-model="input1"
            placeholder="请输入内容"
            suffix-icon="el-icon-search"
            class="item-input"
            @input="searchCategory"
            @focus="searchLevel(1)"
          ></el-input>
        </div>
        <ul>
          <li
            v-for="item in fristCategry"
            :key="item.categoryId"
            class="item-name e-pointer"
            :class="{ active: isForActive1 == item.categoryId }"
            @click="showNext(item, 2)"
          >
            <span>{{ item.categoryName }}</span>
            <i class="el-icon-arrow-right"></i>
          </li>
        </ul>
      </div>
      <div v-show="level > 1" class="item-box">
        <div class="item-input-wrap">
          <el-input
            v-model="input2"
            placeholder="请输入内容"
            suffix-icon="el-icon-search"
            class="item-input"
            @input="searchCategory"
            @focus="searchLevel(2)"
          ></el-input>
        </div>
        <ul>
          <li
            v-for="item in secCategry"
            :key="item.categoryId"
            class="item-name e-pointer"
            :class="{ active: isForActive2 == item.categoryId }"
            @click="showNext(item, 3)"
          >
            <span>{{ item.categoryName }}</span>
            <i class="el-icon-arrow-right"></i>
          </li>
        </ul>
      </div>
      <div v-show="level > 2" class="item-box">
        <div class="item-input-wrap">
          <el-input
            v-model="input3"
            placeholder="请输入内容"
            suffix-icon="el-icon-search"
            class="item-input"
            @input="searchCategory"
            @focus="searchLevel(3)"
          ></el-input>
        </div>
        <ul>
          <li
            v-for="item in thirdCategry"
            :key="item.categoryId"
            class="item-name e-pointer"
            :class="{ active: isForActive3 == item.categoryId }"
            @click="showNext(item, 4)"
          >
            <span>{{ item.categoryName }}</span>
            <i v-if="!item.isLeaf" class="el-icon-arrow-right"></i>
          </li>
        </ul>
      </div>
      <div v-show="level > 3" class="item-box">
        <div class="item-input-wrap">
          <el-input
            v-model="input4"
            placeholder="请输入内容"
            suffix-icon="el-icon-search"
            class="item-input"
            @input="searchCategory"
            @focus="searchLevel(4)"
          ></el-input>
        </div>
        <ul>
          <li
            v-for="item in forCategry"
            :key="item.categoryId"
            class="item-name e-pointer"
            :class="{ active: isForActive4 == item.categoryId }"
            @click="showNext(item, 5)"
          >
            {{ isForActive4 }}/{{ item.categoryId }}
            <span>{{ item.categoryName }}</span>
            <i v-if="!item.isLeaf" class="el-icon-arrow-right"></i>
          </li>
        </ul>
      </div>
    </div>
    <div slot="footer">
      <eui-btn class="submit-btn btn" type="primary" @click="sendMessage"
        >确定</eui-btn
      >
    </div>
  </el-dialog>
</template>

<script>
import Api from '@/modules/projectA/api/enquiry';
import EuiBtn from 'epec-ui/src/package/eui-btn/index';

export default {
  components: { EuiBtn },
  props: {
    categoryVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paramsObj: {},
      // 类目搜索
      input1: '',
      input2: '',
      input3: '',
      input4: '',
      // 类目1-4数组
      fristCategry: [],
      secCategry: [],
      thirdCategry: [],
      forCategry: [],
      isForActive1: null,
      isForActive2: null,
      isForActive3: null,
      isForActive4: null,
      level: 1,
      isLeaf: 0,
    };
  },
  watch: {
    categoryVisible(oldVal, newVal) {
      if (oldVal) {
        this.level = 1;
        this.getCategoryList(-1, 1);
      }
    },
  },
  methods: {
    // new commit
    sendMessage() {
      if (this.isLeaf != 1) {
        this.$message.warning('请选择末级菜单');
        return;
      }
      this.$emit('getCategoryInfo', this.paramsObj);
      this.$emit('update:categoryVisible', false);
    },
    // 类目弹窗取消
    categoryCancellHandle() {
      // this.categoryVisible = false;
      // 清空搜索内容
      this.input1 = '';
      this.input2 = '';
      this.input3 = '';
      this.input4 = '';
      // 清空数据
      this.fristCategry = [];
      this.secCategry = [];
      this.thirdCategry = [];
      this.forCategry = [];
      this.level = 1;
      this.isForActive1 = null;
      this.isForActive2 = null;
      this.isForActive3 = null;
      this.isForActive4 = null;
      this.$emit('update:categoryVisible', false);
    },
    // 获取搜索列表
    async getCategoryList() {
      const params = {
        isStandard: 2,
      };
      const res = await Api.transferCategoryTree(params);
      if (res.code === '200') {
        this.fristCategry = res.data;
        this.secCategry = [];
        this.thirdCategry = [];
        this.forCategry = [];
      } else {
        this.$message.error(res.message);
      }
    },
    showNext(item, level) {
      // if (this.salesScope == 2) {
      //   if (leaf !== 1) {
      //     this.level = level;
      //   }
      // }
      const {
        categoryId: id,
        isLeaf: leaf,
        categoryName: name,
        children,
      } = item;
      if (level < 5 && children !== undefined && children?.length > 0) {
        this.level = level;
      }

      if (level === 2) {
        this.level1name = name;
        this.thirdCategry = [];
        this.forCategry = [];
        this.isForActive1 = id;
      }
      if (level === 3) {
        this.level2name = name;
        this.forCategry = [];
        this.isForActive2 = id;
      }
      if (level === 4) {
        this.level3name = name;
        this.isForActive3 = id;
      }
      if (level === 5) {
        this.level4name = name;
        this.isForActive4 = id;
      }
      this.paramsObj = { ...item };

      this.isLeaf = leaf;
      if (level === 2) {
        this.fristCategry.map((item) => {
          if (item.categoryId === id) {
            this.secCategry = item.children;
          }
        });
      }
      if (level === 3) {
        this.secCategry.map((item) => {
          if (item.categoryId === id) {
            this.thirdCategry = item.children;
          }
        });
      }
      if (level === 4) {
        this.thirdCategry.map((item) => {
          if (item.categoryId === id) {
            this.forCategry = item.children;
          }
        });
        if (this.forCategry?.length === 0) {
          this.isLeaf = 1;
          this.level4name = null;
          this.isForActive4 = null;
        }
      }
      if (level === 5) {
        this.isLeaf = 1;
        this.thirdCategry.map((item) => {
          if (item.categoryId === id) {
            this.forCategry = item.children;
          }
        });
      }
      // }
    },
    /* async searchCategory(val) {
      console.log(this.level);
      if (val == "") {
        if (this.isActiveLevel == 1) {
          if (this.salesScope == 1) {
            await this.getCategoryListByAgreement();
          } else {
            await this.getCategoryList(-1, this.isActiveLevel);
          }
        }
        if (this.isActiveLevel == 2) {
          if (this.salesScope == 2) {
            await this.getCategoryList(this.isForActive1, this.isActiveLevel);
          } else {
            if (this.level == 2) {
              this.fristCategry.map(item => {
                if (item.categoryId == this.isForActive1) {
                  this.secCategry = item.children;
                }
              });
            }
          }
        }
        if (this.isActiveLevel == 3) {
          if (this.salesScope == 2) {
            await this.getCategoryList(this.isForActive2, this.isActiveLevel);
          } else {
            if (this.level == 3) {
              this.secCategry.map(item => {
                if (item.categoryId == this.isForActive2) {
                  this.thirdCategry = item.children;
                }
              });
            }
          }
        }
        if (this.isActiveLevel == 4) {
          if (this.salesScope == 2) {
            await this.getCategoryList(this.isForActive3, this.isActiveLevel);
          } else {
            if (this.level == 4) {
              this.thirdCategry.map(item => {
                if (item.categoryId == this.isForActive3) {
                  this.forCategry = item.children;
                }
              });
            }
          }
        }
      }
      if (this.isActiveLevel == 1) {
        let res = this.fristCategry.filter(
          item => item.categoryName.indexOf(val) != -1
        );
        console.log(res);
        this.fristCategry = res;
      }
      if (this.isActiveLevel == 2) {
        let res = this.secCategry.filter(
          item => item.categoryName.indexOf(val) != -1
        );
        console.log(res);
        this.secCategry = res;
      }
      if (this.isActiveLevel == 3) {
        let res = this.thirdCategry.filter(
          item => item.categoryName.indexOf(val) != -1
        );
        console.log(res);
        this.thirdCategry = res;
      }
      if (this.isActiveLevel == 4) {
        let res = this.forCategry.filter(
          item => item.categoryName.indexOf(val) != -1
        );
        console.log(res);
        this.forCategry = res;
      }
    }, */
    async searchCategory(val) {
      console.log(this.level);
      if (val === '') {
        if (this.isActiveLevel === 1) {
          await this.getCategoryList(-1, this.isActiveLevel);
        }
        if (this.isActiveLevel === 2) {
          await this.getCategoryList(this.isForActive1, this.isActiveLevel);
        }
        if (this.isActiveLevel === 3) {
          await this.getCategoryList(this.isForActive2, this.isActiveLevel);
        }
        if (this.isActiveLevel === 4) {
          await this.getCategoryList(this.isForActive3, this.isActiveLevel);
        }
      }
      if (this.isActiveLevel === 1) {
        const res = this.fristCategry.filter(
          (item) => item.categoryName.indexOf(val) !== -1
        );
        this.fristCategry = res;
      }
      if (this.isActiveLevel === 2) {
        const res = this.secCategry.filter(
          (item) => item.categoryName.indexOf(val) !== -1
        );
        this.secCategry = res;
      }
      if (this.isActiveLevel === 3) {
        const res = this.thirdCategry.filter(
          (item) => item.categoryName.indexOf(val) !== -1
        );
        this.thirdCategry = res;
      }
      if (this.isActiveLevel === 4) {
        const res = this.forCategry.filter(
          (item) => item.categoryName.indexOf(val) !== -1
        );
        this.forCategry = res;
      }
    },
    searchLevel(val) {
      this.level = val;
      this.isActiveLevel = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.category {
  display: flex;
  // justify-content: space-between;
  .item-box {
    padding: 10px;
    width: 23%;
    border: 1px solid #ddd;
    margin-right: 20px;
    .item-input-wrap {
      ::v-deep .el-input__inner {
        border-radius: 0;
        height: 36px;
      }
      ::v-deep .el-input__icon {
        line-height: 36px;
      }
    }
    ul {
      height: 360px;
      overflow: auto;
    }
    .item-input {
      margin-bottom: 10px;
    }
    .item-name {
      display: flex;
      justify-content: space-between;
      padding: 3px 0;
      &.active {
        background: #f4f7ff;
        color: #0064c8;
      }
    }
  }
}

::v-deep .el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .el-dialog__headerbtn {
    top: 8px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
}

::v-deep .el-dialog__footer {
  display: flex;
  justify-content: center;
  .btn {
    width: 80px;
    text-align: center;
    height: 30px;
    line-height: 27px;
    cursor: pointer;
  }

  .submit-btn {
    background: #2587ff;
    border: 1px solid #2587ff;
    color: #ffffff;
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
}

::v-deep .el-dialog__body {
  padding: 10px;
}
</style>
